import React, { type ReactNode, useEffect, useRef } from 'react';
import { styled } from '@compiled/react';
import FocusLock from 'react-focus-lock';
import { token } from '@atlaskit/tokens';
import { layers } from '@atlassian/jira-common-styles/src/main.tsx';
import {
	DEFAULT_MENU_WIDTH,
	CONTEXT_MENU_SUBMENU_TESTID,
} from '../../../../../../common/constants.tsx';

type Props = {
	children?: ReactNode;
	width?: number;
	shouldOverflowChildren?: boolean;
	persistentFocus?: boolean;
};

const stopPropagation = (e: MouseEvent) => {
	e.stopPropagation();
};

export const SubmenuContainer = ({
	children,
	width = DEFAULT_MENU_WIDTH,
	shouldOverflowChildren,
	persistentFocus = false,
}: Props) => {
	const contextMenuContainerRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const eventRef = contextMenuContainerRef.current;
		eventRef?.addEventListener('mousedown', stopPropagation);
		return () => {
			eventRef?.removeEventListener('mousedown', stopPropagation);
		};
	}, []);

	return (
		<FocusLock disabled={!persistentFocus} persistentFocus={persistentFocus} autoFocus={false}>
			<ContextMenuContainer
				width={width}
				ref={contextMenuContainerRef}
				data-testid={CONTEXT_MENU_SUBMENU_TESTID}
				shouldOverflowChildren={shouldOverflowChildren}
			>
				{children}
			</ContextMenuContainer>
		</FocusLock>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContextMenuContainer = styled.div<{
	width: number;
	shouldOverflowChildren?: boolean;
}>({
	backgroundColor: token('elevation.surface.overlay', '#fff'),
	maxHeight: 400,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	overflowX: ({ shouldOverflowChildren }) => (shouldOverflowChildren ? 'visible' : 'hidden'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	overflowY: ({ shouldOverflowChildren }) => (shouldOverflowChildren ? 'visible' : 'auto'),
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layers.modal,
	borderRadius: 3,
	display: 'block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ width }) => `${width}px`,
});
